/**
 * 全局常量配置。
 */

/** 逻辑分辨率（竖版 3:4），所有游戏坐标以此为基准 */
export const VIEW_W = 480;
export const VIEW_H = 640;

/** 敌弹对象池容量（Lunatic 弹量上调后留足余量） */
export const MAX_ENEMY_BULLETS = 2000;

/** 自机弹对象池容量 */
export const MAX_PLAYER_BULLETS = 400;

/** 粒子对象池容量 */
export const MAX_PARTICLES = 800;

/** 道具对象池容量 */
export const MAX_ITEMS = 200;

/** 固定逻辑步长（秒） */
export const FIXED_DT = 1 / 60;
